/* eslint-disable import/extensions */
import React from 'react';
import { HashRouter, Switch } from 'react-router-dom';

import ChangeForgotPassword from '~/pages/ChangeForgotPassword';
import Data from '~/pages/Data';
import DataLists from '~/pages/DataLists';
import EditDataList from '~/pages/DataLists/EditDataList';
import EditDataListData from '~/pages/DataLists/EditDataListData';
import Executions from '~/pages/Executions';
import Forbidden from '~/pages/Forbidden';
import ForgotPassword from '~/pages/ForgotPassword';
import Processes from '~/pages/Processes';
import NewProcessForm from '~/pages/Processes/NewProcessForm';
import Requests from '~/pages/Requests';
import SignIn from '~/pages/SignIn';
import Tasks from '~/pages/Tasks';
import ExecuteTask from '~/pages/Tasks/ExecuteTask';
import Users from '~/pages/Users';
import NewUser from '~/pages/Users/NewUsers';
import Profile from '~/pages/Users/Profile';
import { urls, permissions } from '~/types/constants';

import Route from './Route';

const Routes: React.FC = () => {
  return (
    <HashRouter>
      <Switch>
        <Route path={urls.SIGNIN} exact component={SignIn} />
        <Route path={urls.FORGOT_PASSWORD} exact component={ForgotPassword} />
        <Route
          path={urls.CHANGE_FORGOT_PASSWORD}
          exact
          component={ChangeForgotPassword}
        />
        <Route path={urls.FORBIDDEN} component={Forbidden} isPrivate />
        <Route
          path={urls.USERS}
          exact
          component={Users}
          isPrivate
          enabledPermissions={[permissions.VIEW_ALL_USER]}
        />
        <Route path={urls.USERS_NEW} component={NewUser} isPrivate />
        <Route path={urls.PROFILE} component={Profile} isPrivate />
        <Route
          path={urls.PROCESSES}
          component={Processes}
          exact
          isPrivate
          enabledPermissions={[permissions.CREATE_REQUEST]}
        />
        <Route
          path={urls.PROCESSES_NEW}
          component={NewProcessForm}
          exact
          isPrivate
          enabledPermissions={[permissions.VIEW_REQUEST]}
        />
        <Route
          path={urls.REQUESTS}
          component={Requests}
          isPrivate
          enabledPermissions={[permissions.VIEW_REQUEST]}
        />
        <Route
          path={urls.EXECUTIONS}
          component={Executions}
          isPrivate
          enabledPermissions={[permissions.VIEW_EXECUTIONS]}
        />
        <Route
          path={urls.DATA}
          component={Data}
          isPrivate
          enabledPermissions={[
            permissions.VIEW_REPORTS,
            permissions.VIEW_DASHBOARD,
          ]}
        />
        <Route
          path={urls.TASK_EXECUTE}
          component={ExecuteTask}
          isPrivate
          enabledPermissions={[permissions.EXECUTE_TASK]}
        />
        <Route
          path={urls.TASKS}
          component={Tasks}
          isPrivate
          enabledPermissions={[permissions.VIEW_ALL_TASKS]}
        />

        <Route
          path={urls.DATA_LISTS}
          exact
          component={DataLists}
          enabledPermissions={[permissions.VIEW_ALL_DATA_LISTS]}
          isPrivate
        />
        <Route
          path={urls.DATA_LISTS_NEW}
          component={EditDataList}
          enabledPermissions={[permissions.CREATE_DATA_LIST]}
          isPrivate
        />
        <Route
          path={urls.DATA_LISTS_UPDATE}
          component={EditDataList}
          enabledPermissions={[permissions.UPDATE_DATA_LIST]}
          isPrivate
        />
        <Route
          path={urls.DATA_LISTS_UPDATE_DATA}
          component={EditDataListData}
          enabledPermissions={[permissions.UPDATE_DATA_LIST]}
          isPrivate
        />
        <Route component={SignIn} />
      </Switch>
    </HashRouter>
  );
};

export default Routes;
